import React from "react";

const SvgCodePrefix = props => <svg width="1em" height="1em" viewBox="0 0 16 17" {...props}><path d="M8.12 12.438c0 .129.1.235.22.235h5.44c.122 0 .222-.106.222-.235v-1.412c0-.13-.1-.235-.221-.235H8.34c-.12 0-.22.105-.22.235v1.412zm-5.733.179l5.647-4.735a.237.237 0 000-.362L2.387 2.788A.234.234 0 002 2.967v1.844c0 .07.03.135.086.18l3.23 2.711-3.23 2.712a.238.238 0 00-.086.18v1.844c0 .2.233.308.386.179z" /></svg>;

export default SvgCodePrefix;